// extracted by mini-css-extract-plugin
export default {"wrapper":"ActiveBadge_wrapper__ICG5k","indicator":"ActiveBadge_indicator__Wmr1J","text":"ActiveBadge_text__wHyFz"};